import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  GET_DROPDOWNS_DATA,
  FILE_COMPLAIN,
  SITE_TYPES,
  GET_SITE_INFO,
  GET_COMPLAINS_LIST,
  COMPLAIN_RAISED_TICKET,
  CLOSED_COMPAIN,
  REOPEN_COMPLAIN,
  GET_VIEW_COMPAIN,
  GET_TS_QUESTIONNAIRE,
  POST_TS_QUESTIONNAIRE,
  GET_COMPLAINS,
  GET_COMPLAINS_LIST_L2,
  GET_CATEGORY_CX_CATEGORY,
  GET_CATEGORY_CX_L1,
  GET_CATEGORY_CX_L2,
  GET_CATEGORY_CX_L3,
  SAVE_ASSIGNEE_TICKET,
  ISSUE_SUBTYPE,
  FETCH_ALL_ISSUES,
  SAVE_ISSUE_REPLY,
  CENTRAL_TECH_COMPLAINS,
  CENTRAL_TECH_COMPLAINS_LIST,
  CENTRAL_TECH_LIST,
  CENTRAL_TECH_CHANGE,
  SAVE_CTE_COMPLAIN_REMARKS,
  CTE_ISSUE_LISTING,
} from "./type";

export const getSiteTypes = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.fileComplain.siteTypes
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_TYPES, payload: data.response.data });
    return data.response.data;
  }
};

export const getSiteInformation = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.siteSearch
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_SITE_INFO, payload: data.response.data.resultSets });
    return data.response.data;
  }
};

export const getFormDropdowns = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.dropdownsData}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_DROPDOWNS_DATA, payload: data.response.data });
    return true;
  }
};

export const getComplains = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.getComplains}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_COMPLAINS, payload: data.response.data });
    return data;
  }
};

export const raiseComplain = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.complainRaised
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FILE_COMPLAIN, payload: data.response.data });
    return data.response.data;
  }
};

export const updateComplainCategories = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.fileComplain.updateComplainCategory}`
  );
  if (res) {
    return true;
  }
};

export const fetchFaqs = (category_id) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.fileComplain.fetchFaqs}?category_id=${category_id}`
    );
    const subcategoryData = res?.data?.result || [];
    dispatch({ type: FILE_COMPLAIN, payload: subcategoryData });
    return subcategoryData;
  } catch (err) {
    return [];
  }
};

export const ticketCategories = () => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.get,
      "",
      Config.fileComplain.fetchTicketCategory
    );
    const ticketCategoryData = res?.data?.result || [];
    dispatch({ type: FILE_COMPLAIN, payload: ticketCategoryData });
    return ticketCategoryData;
  } catch (err) {
    return [];
  }
};

export const fetchComplainList = (filterData = null, page = 1) => async (dispatch) => {
  // alert(page);
  const res = await callWebService(
    callTypes.get,
    "",
    filterData === null
      ? `${Config.fileComplain.fetchComplain}?page=${page}`
      : `${Config.fileComplain.fetchComplain}?status=${filterData.internalStatus}&site_no=${filterData.site_no}&cx_category=${filterData.cx_category}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&fd_ticket_id=${filterData.fd_ticket_id}&complain_id=${filterData.complain_id}&ticket_tags_id=${filterData.ticket_tags_id}&city_id=${filterData.city_id || ''}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_COMPLAINS_LIST, payload: data.response.data });
    return true;
  }
};

export const fetchAllIssuesList = (filterData = null, page = 1, complainId = null, isLeadx = true) => async (dispatch) => {
  let baseUrl = `${Config.fileComplain.fetchAllIssue}?page=${page}&is_leadx=${isLeadx}`;
  const queryParams = [];

  if (filterData) {
    if (filterData.internalStatus) {
      queryParams.push(`status=${filterData.internalStatus}`);
    }
    if (filterData.site_no) {
      queryParams.push(`site_no=${filterData.site_no}`);
    }
    if (filterData.cx_category) {
      queryParams.push(`cx_category=${filterData.cx_category}`);
    }
    if (filterData.client_name) {
      queryParams.push(`client_name=${filterData.client_name}`);
    }
    if (filterData.assignee_id) {
      queryParams.push(`assignee_id=${filterData.assignee_id}`);
    }
    if (filterData.fromDate) {
      queryParams.push(`fromDate=${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      queryParams.push(`toDate=${filterData.toDate}`);
    }
    if (filterData.fd_ticket_id) {
      queryParams.push(`fd_ticket_id=${filterData.fd_ticket_id}`);
    }
    if (filterData.complain_id) {
      queryParams.push(`complain_id=${filterData.complain_id}`);
    }
    if (filterData.ticket_tags_id) {
      queryParams.push(`ticket_tags_id=${filterData.ticket_tags_id}`);
    }
  }

  if (complainId) {
    queryParams.push(`complain_id=${complainId}`);
  }

  const url = `${baseUrl}&${queryParams.join('&')}`;

    const res = await callWebService(callTypes.get, "", url);
    
    if (res) {
      const { data } = res;
      dispatch({ type: FETCH_ALL_ISSUES, payload: data.response.data });
      return true;
    }
};


export const fetchCteIssueList = (filterData = null, page = 1, complainId = null, isLeadx = true) => async (dispatch) => {
  let baseUrl = `${Config.fileComplain.cteIssueListing}?page=${page}&is_leadx=${isLeadx}`;
  const queryParams = [];

  if (filterData) {
    if (filterData.internalStatus) {
      queryParams.push(`status=${filterData.internalStatus}`);
    }
    if (filterData.site_no) {
      queryParams.push(`site_no=${filterData.site_no}`);
    }
    if (filterData.cx_category) {
      queryParams.push(`cx_category=${filterData.cx_category}`);
    }
    if (filterData.client_name) {
      queryParams.push(`client_name=${filterData.client_name}`);
    }
    if (filterData.assignee_id) {
      queryParams.push(`assignee_id=${filterData.assignee_id}`);
    }
    if (filterData.fromDate) {
      queryParams.push(`fromDate=${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      queryParams.push(`toDate=${filterData.toDate}`);
    }
    if (filterData.fd_ticket_id) {
      queryParams.push(`fd_ticket_id=${filterData.fd_ticket_id}`);
    }
    if (filterData.complain_id) {
      queryParams.push(`complain_id=${filterData.complain_id}`);
    }
    if (filterData.ticket_tags_id) {
      queryParams.push(`ticket_tags_id=${filterData.ticket_tags_id}`);
    }
  }

  if (complainId) {
    queryParams.push(`complain_id=${complainId}`);
  }

  const url = `${baseUrl}&${queryParams.join('&')}`;

    const res = await callWebService(callTypes.get, "", url);
    
    if (res) {
      const { data } = res;
      // Go backend: { status: 0, message, data: { resultSets, messages } }
      const payload = data.data ?? data.response?.data;
      dispatch({ type: FETCH_ALL_ISSUES, payload });
      return true;
    }
};

export const fetchComplainListL2Support = (filterData = null, page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    filterData === null
      ? `${Config.fileComplain.fetchComplainSupport}?page=${page}`
      : `${Config.fileComplain.fetchComplainSupport}?internal_status=${filterData.internalStatus || ''}&status=${filterData.status || ''}&site_no=${filterData.site_no || ''}&client_name=${filterData.client_name || ''}&assignee_id=${filterData.assignee_ids || ''}&fromDate=${filterData.fromDate || ''}&toDate=${filterData.toDate || ''}&fd_ticket_id=${filterData.fd_ticket_id || ''}&complain_id=${filterData.complain_id || ''}&page=${page}`
  );
  if (res) {
    const { data } = res;
    // Go backend: { status: 0, message, data: { resultSets, total, ... } }
    const payload = data.data ?? data.response?.data;
    dispatch({ type: GET_COMPLAINS_LIST_L2, payload });
    return true;
  }
};

export const viewDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.viewComaplain}?complain_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_VIEW_COMPAIN, payload: data.response.data });
    return true;
  }
};

export const complainRaisedTicket = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.complainRaisedTicket
  );
  if (res) {
    const { data } = res;
    dispatch({ type: COMPLAIN_RAISED_TICKET, payload: data.response.data });
    return true;
  }
};

export const saveAssigneeDetails = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.saveAssigneeTicket
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_ASSIGNEE_TICKET, payload: data.response.data });
    return true;
  }
};

// saveComplaintReply
export const saveComplaintReply = (data,id,onlyReply) => async (dispatch) => {
  const dataSet = {
    "data" : data,
    "complaint_id" : id,
    "onlyReply" : onlyReply,
  };
  // console.log(dataSet); return false;
  const res = await callWebService(
    callTypes.post,
    dataSet,
    Config.fileComplain.saveComplaintReply
  );
  if (res) {
    const { data } = res;
    // dispatch({ type: COMPLAIN_RAISED_TICKET, payload: data.response.data });
    return true;
  }
};

export const saveComplaintReplySupport = (data,id) => async (dispatch) => {
  const dataSet = {
    "data" : data,
    "complaint_id" : id
  };
  // console.log(dataSet); return false;
  const res = await callWebService(
    callTypes.post,
    dataSet,
    Config.fileComplain.saveComplaintReplySupport
  );
  if (res) {
    const { data } = res;
    // dispatch({ type: COMPLAIN_RAISED_TICKET, payload: data.response.data });
    return true;
  }
};


export const closeComplain = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.closeComplain
  );
  if (res) {
    const { data } = res;
    // Go backend: { status: 0, message, data: null }
    const payload = data.data ?? data.response?.data;
    dispatch({ type: CLOSED_COMPAIN, payload });
    return true;
  }
};
export const reopenComplain = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.reopenComplain
  );
  if (res) {
    const { data } = res;
    dispatch({ type: REOPEN_COMPLAIN, payload: data.response.data });
    return true;
  }
};

export const getTsQuestionnaire = (id) => async (dispatch) => {
  dispatch({ type: GET_TS_QUESTIONNAIRE, payload: null });
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.getTroubleshoot}?material_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_TS_QUESTIONNAIRE, payload: data.response.data });
    return true;
  }
};

export const postTsQuestionnaire = (data) => async (dispatch) => {
  dispatch({ type: POST_TS_QUESTIONNAIRE, payload: null });
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.postTroubleshoot
  );
  if (res) {
    const { data } = res;
    if(data.response.status) {
      dispatch({ type: POST_TS_QUESTIONNAIRE, payload: data.response.message });
      return true;
    }
  }
};

export const getCategoryCX = (categoryType = null, category = null, l1 = null, l2 = null) => async (dispatch) => {
  dispatch({ type: GET_CATEGORY_CX_CATEGORY, payload: null });
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.getCategoryCX}?categoryType=${categoryType}&category=${category}&l1=${l1}&l2=${l2}`
  );
  if (res) {
    const { data } = res;
    if(data.message == "category"){
      // dispatch({ type: GET_CATEGORY_CX_CATEGORY, payload: data.response.data });
      return data.response.data;
    }
    else if(data.message == "l1") {
      // dispatch({ type: GET_CATEGORY_CX_L1, payload: data.response.data });
      return data.response.data;
    }
    else if(data.message == "l2"){
      // dispatch({ type: GET_CATEGORY_CX_L2, payload: data.response.data });
      return data.response.data;
    }
    else if(data.message == "l3"){
      // dispatch({ type: GET_CATEGORY_CX_L3, payload: data.response.data });
      return data.response.data;
    }
    return true;
  }
};

export const setCategoryCX = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.setCategoryCX
  );
  if (res) {
    const { data } = res;
    if(data.response.status) {
      return true;
    }
    return false;
  }
};

export const closeDuplicateComplaint = (id, mergeId) => async (dispatch) => {
  const dataSet = {
    "complaint_id" : id,
    "merge_id" : mergeId
  };
  // console.log(dataSet); return false;
  const res = await callWebService(
    callTypes.post,
    dataSet,
    Config.fileComplain.closeDuplicateComplaint
  );
  if (res) {
    const { data } = res;
    // dispatch({ type: COMPLAIN_RAISED_TICKET, payload: data.response.data });
    return true;
  }
};

export const subIssueDropdown = (id) => async (dispatch) => {
  if (id === undefined || id === null || id === '' || Number(id) <= 0) {
    return false;
  }
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.getSubIssueDropDown}?parent_id=${id}`
  );
  if (res) {
    const { data } = res;
    const payload = data.response ?? { data: data.data, status: data.status === 0 };
    dispatch({ type: ISSUE_SUBTYPE, payload });
    return true;
  }
};

export const saveRaiseIssueSupport = (data,id) => async (dispatch) => {
  const dataSet = {
    "data" : data,
    "complaint_id" : id
  };
  const res = await callWebService(
    callTypes.post,
    dataSet,
    Config.fileComplain.saveIssueReply
  );
  if (res) {
    const { data } = res;
    // dispatch({ type: COMPLAIN_RAISED_TICKET, payload: data.response.data });
    return true;
  }
};

export const centralTechComplainRaise = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.fileComplain.centralTechComplain}`
  );
  if (res) {
    const { data } = res;
    const payload = {
      status: data.status === 0 ? 200 : (data.status_code ?? data.status),
      message: data.message ?? data.response?.message ?? '',
      data: data.data ?? data.response?.data,
    };
    dispatch({ type: CENTRAL_TECH_COMPLAINS, payload });
    return { ok: data.status === 0 || data.response?.status === true, message: payload.message };
  }
  return { ok: false, message: '' };
};

// centralTechComplainRaiseList uses the same filter shape as RmTicketsFilterForm (complaintFilter).
export const centralTechComplainRaiseList = (page = 1, filters = {}) => async (dispatch) => {
  const params = new URLSearchParams({ page });
  if (filters) {
    if (filters.site_no)          params.append('site_no',      filters.site_no);
    if (filters.infra_id)         params.append('infra_id',     filters.infra_id);
    if (filters.client_name)      params.append('client_name',  filters.client_name);
    if (filters.complain_id)      params.append('complain_id',  filters.complain_id);
    if (filters.fd_ticket_id)     params.append('fd_ticket_id', filters.fd_ticket_id);
    if (filters.assignee_ids)     params.append('assigned_to',  filters.assignee_ids);
    if (filters.internalStatus)   params.append('status',       filters.internalStatus);
    if (filters.fromDate && filters.fromDate !== 'Invalid date')
      params.append('fromDate', filters.fromDate);
    if (filters.toDate && filters.toDate !== 'Invalid date')
      params.append('toDate', filters.toDate);
    if (filters.cx_category)      params.append('cx_category',  filters.cx_category);
    // Legacy filter keys (backward-compat)
    if (filters.ticket_id)        params.append('complain_id',  filters.ticket_id);
    if (filters.site_name)        params.append('client_name',  filters.site_name);
    if (filters.assigned_to)      params.append('assigned_to',  filters.assigned_to);
    if (filters.status)           params.append('status',       filters.status);
  }
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.fileComplain.centralTechComplainList}?${params.toString()}`
  );
  if (res) {
    const { data } = res;
    // Go backend: { status: 0, message, data: { data: [...], total, ... } }
    const payload = data.data ?? data.response?.data;
    dispatch({ type: CENTRAL_TECH_COMPLAINS_LIST, payload });
    return true;
  }
};

export const centralTechList = (page = 1) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.fileComplain.centralTechList}?page=${page}`
  );
  if (res) {
    const { data } = res;
    // Go backend: { status: 0, message, data: [...] }
    const payload = data.data ?? data.response?.data;
    dispatch({ type: CENTRAL_TECH_LIST, payload });
    return true;
  }
};

export const changeCentralTech = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.fileComplain.changeCentralTech}`
  );
  if (res) {
    const { data } = res;
    const ok = data.status === 0 || data.response?.status === true;
    const payload = {
      status: data.status === 0 ? 200 : (data.status_code ?? data.status),
      message: data.message ?? data.response?.message ?? '',
      data: data.data ?? data.response?.data,
    };
    dispatch({ type: CENTRAL_TECH_CHANGE, payload });
    return { ok, message: payload.message };
  }
  return { ok: false, message: '' };
};

export const saveCteComplainRemarks = (data) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.fileComplain.saveCteComplainRemarks}`
  );
  if (res) {
    const { data } = res;
    // Go backend: { status: 0, message, data: true }
    const ok = data.status === 0;
    dispatch({ type: SAVE_CTE_COMPLAIN_REMARKS, payload: ok });
    return ok;
  }
};






